import Select from 'react-select';
import styled from 'styled-components/macro';
export default styled(Select).attrs(() => ({
  className: 'StyledSelect',
  classNamePrefix: 'StyledSelect'
}))``;
